<script lang="ts" setup>
import { nextTick, ref, watch } from "vue";

import type { Conversation } from "./types/Conversation";

const props = defineProps<{
  conversation: Conversation;
}>();

const conversationTemplateRef = ref<HTMLDivElement | null>(null);

const scrollToBottom = async () => {
  await nextTick();
  const container = conversationTemplateRef.value?.closest(".conversation-container");

  if (container) {
    container.scroll({
      top: container.scrollHeight,
      behavior: "smooth",
    });
  }
};

watch(
  () => props.conversation.length,
  () => scrollToBottom(),
);
</script>

<template>
  <div v-if="props.conversation.length" ref="conversationTemplateRef" class="conversation">
    <slot></slot>
  </div>
</template>

<style scoped>
.conversation {
  display: flex;
  flex-direction: column;
}
</style>
